export default __webpack_public_path__ + "static/media/moon.2c851e83.svg";